import { compose } from 'lodash/fp'
import React from 'react'
import { NumberFormatValues } from 'react-number-format'
import Flex from 'typescript-styled-flex'
import { deformatNumber } from '../../../utils/Money'
import { PriceFormat } from '../Custom'
import FormElement from '../FormElement'
import { IFormElementProps } from '../FormElement/FormInput'
import withReduxForm from '../withReduxForm'
import withRedux from './withRedux'
import Input from './Input'
import Currency from './Currency'

interface IPriceInputProps {
  allowNegative?: boolean
  disableFocus?: boolean
  allowNullValue?: boolean
  decimalSeparator?: string | boolean
  decimalScale?: number | null
  isAllowed?: any
  customAfterIconStyle?: any
  currencyStyle?: any
}

const PriceInput = FormElement(
  ({
    name,
    placeholder,
    isSelected,
    errorMsg,
    warningMsg,
    readonly,
    onChange,
    onFocus,
    onBlur,
    required,
    value,
    disabled,
    withAfterIcon,
    alignCenter = false,
    size = 1,
    min = undefined,
    max = undefined,
    className,
    disableFocus = false,
    currency,
    allowNegative = false,
    alignCurrency = false,
    inputStyle,
    isSmallReservation,
    nullAtDisabled,
    decimalSeparator,
    decimalScale,
    onAfterIconClick,
    allowNullValue = false,
     dummyError = false,
     currencyStyle = {},
     little = false,
     customAfterIconStyle= {},
    isAllowed,
  }: IFormElementProps & IPriceInputProps) => {
    function change(values: NumberFormatValues) {
      if (onChange && !disabled) {
        let changed = values.value
        if (values.value === '' && !allowNullValue) {
          changed = '0.00'
        }
        onChange(changed)
      }
    }

    function blur(e) {
      if (onBlur) {
        const nextVal =
          !value && !allowNullValue ? '0.00' : deformatNumber(value) //Fix for redux form
        if (e.currentTarget) {
          e.currentTarget.value = nextVal
        }
        e.target.value = nextVal
        onBlur(e)
      }
    }

    return (
      <Flex
        justifyEnd={true}
        alignStart={!alignCenter}
        alignCenter={alignCenter}
        style={{ position: 'relative' }}
      >
        <PriceFormat
          customInput={Input}
          little={little}
          name={name}
          style={{ ...{ textAlign: 'start' }, ...inputStyle }}
          placeholder={placeholder}
          selected={!disableFocus && isSelected}
          error={!dummyError && errorMsg && errorMsg !== ''}
          size={size}
          warning={warningMsg && warningMsg !== ''}
          type={'text'}
          onValueChange={change}
          required={required}
          readOnly={readonly}
          alignCurrency={alignCurrency}
          onFocus={onFocus}
          isNumericString={true}
          inputMode={'numeric'}
          value={
            nullAtDisabled && disabled
              ? ''
              : (value === '0.00' || value === 0) && !allowNullValue
              ? ''
              : value
          }
          disabled={disabled}
          className={className}
          // Commented out to not reduce number
          onBlur={blur}
          smallReservation={isSmallReservation}
          withAfterIcon={withAfterIcon !== undefined && withAfterIcon !== null}
          allowNegative={allowNegative}
          currency={Boolean(currency)}
          decimalSeparator={decimalSeparator}
          decimalScale={decimalScale}
          isAllowed={isAllowed}
          data-cy={className}
        />
        <Flex
          className={className}
          style={{
            position: 'absolute',
            right: alignCurrency
              ? `${48 * size}px`
              : withAfterIcon !== undefined && withAfterIcon !== null
                ? `${35 * size}px`
                : `${10 * size}px`,
            top: little? '7px':`${11 * size}px`,
            color: '#C2C2C2',
            fontFamily: 'Montserrat',
            fontSize: '12px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: 'normal',
            letterSpacing: '0.024px',
          }}
        >
          <div style={{
            width: '1px',
            height: little? '12px':'15px',
            background: '#D7D7D7',
            marginRight: little? '6px':'15px',
          }} />
          <Currency style={currencyStyle} little={little} size={size}>{currency}</Currency>
        </Flex>
        {withAfterIcon && (
          <Flex
            onClick={onAfterIconClick}
            style={{
              cursor: 'pointer',
              position: 'absolute',
              right: `${10 * size}px`,
              top: `${11 * size}px`,
              ...customAfterIconStyle
            }}
          >
            {withAfterIcon}
          </Flex>
        )}
      </Flex>
    )
  },
)

const ReduxField: React.ComponentType<
  IFormElementProps & IPriceInputProps
> = compose(
  withReduxForm,
  withRedux,
)(PriceInput)

export default ReduxField
export { PriceInput }
